/**
 * 基础auth请求类
 */

import { BaseClient } from '@acgn/herm/src/api/baseClient';
// import { getToken } from '@/util/auth';

class BaseAuthClient extends BaseClient {
  constructor(cfg: any) {
    super(cfg);

    this.axiosInstance.interceptors.request.use((config: any) => {
      // (config.headers.common as any).Authorization = `Bearer ${getToken()}`;
      return config;
    });
  }
}

export default BaseAuthClient;
